// Cookie Consent — GDPR/CCPA compliance
// Loaded after cookieconsent.umd.js; initializes banner with category-based blocking.
//
// IMPORTANT: Only blocks "analytics" category. Shopify's own session/storefront
// scripts (loaded via content_for_header) are in the "necessary" category and
// are always allowed — blocking them would break checkout.
(function() {
  'use strict';
  if (typeof CookieConsent === 'undefined') return;
  if (window.Shopify && window.Shopify.designMode) return;

  CookieConsent.run({
    categories: {
      necessary: { enabled: true, readOnly: true },
      analytics: { enabled: false }
    },
    language: {
      default: 'en',
      translations: {
        en: {
          consentModal: {
            title: 'We use cookies',
            description: 'We use cookies to understand how you use our site and improve your experience. Necessary cookies are always active. You can choose to accept or reject analytics cookies.',
            acceptAllBtn: 'Accept all',
            rejectAllBtn: 'Reject all',
            showPreferencesBtn: 'Manage preferences'
          },
          preferencesModal: {
            title: 'Cookie preferences',
            acceptAllBtn: 'Accept all',
            rejectAllBtn: 'Reject all',
            savePreferencesBtn: 'Save preferences',
            sections: [
              {
                title: 'Necessary cookies',
                description: 'Required for the shop to function. Cannot be disabled.',
                linkedCategory: 'necessary'
              },
              {
                title: 'Analytics cookies',
                description: 'Help us understand how visitors use the site so we can improve it.',
                linkedCategory: 'analytics'
              }
            ]
          }
        }
      }
    }
  });
})();
